import { render, staticRenderFns } from "./customerPlacingHistory.vue?vue&type=template&id=49680d61&"
import script from "./customerPlacingHistory.vue?vue&type=script&lang=js&"
export * from "./customerPlacingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports